import { useState } from "react";

export function useManualMerge() {
  const [isMerging, setIsMerging] = useState(false);
  const [mergeError, setMergeError] = useState();
  const [mergeSuccess, setMergeSuccess] = useState(false);

  async function handleManualMerge(mergedFinalData, selectedCases) {
    setIsMerging(true);
    setMergeError(null);
    setMergeSuccess(false);

    try {
      // 1. Detect repeatable fields dynamically
      const allKeys = new Set();
      selectedCases.forEach((record) => {
        Object.keys(record).forEach((key) => allKeys.add(key));
      });

      const repeatableFields = Array.from(allKeys).filter((key) =>
        selectedCases.some((record) => Array.isArray(record[key]))
      );

      // 2. Build merged CASE object
      const mergedCase = { ...mergedFinalData };

      for (const field of repeatableFields) {
        for (const record of selectedCases) {
          if (Array.isArray(record[field]) && record[field].length > 0) {
            mergedCase[field] = record[field];
            break;
          }
        }
      }

      // 3. Build list of merged case IDs
      // const mergedIds = selectedCases.map((c) => c.id || c.PERSON_ID);

      // 4. Prepare final payload
      const payload = {
        MODE: "MANUAL",
        CASE: mergedCase,
        MERGES: selectedCases,
      };

      // 5. Send API request
      const response = await fetch("/api/mergeCases", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Merge failed: ${errorText}`);
      }

      setMergeSuccess(true);
      return { success: true };
    } catch (err) {
      console.error("Merge error:", err);
      setMergeError(err.message || "Unknown error");
      return { success: false, error: err.message || "Unknown error" };
    } finally {
      setIsMerging(false);
    }
  }

  return {
    handleManualMerge,
    isMerging,
    mergeError,
    mergeSuccess,
  };
}
